import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { RegisterForm } from './RegisterForm';
import { WhatsAppJoinModal } from './WhatsAppJoinModal';
import { SparklesIcon } from 'lucide-react';
interface HeroProps {
  onFormSuccess: () => void;
  isFormSubmitted: boolean;
}
export const Hero: React.FC<HeroProps> = ({
  onFormSuccess,
  isFormSubmitted
}) => {
  const [showForm, setShowForm] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const handleOpenForm = () => {
    setShowForm(true);
  };
  const handleFormSuccess = () => {
    setShowWhatsAppModal(true);
    onFormSuccess();
  };
  return <section className="flex flex-col justify-center items-center px-4 py-8 md:py-12 relative overflow-hidden" data-id="element-136">
      {/* Efecto de luz superior */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-64 bg-blue-500/30 blur-[120px] rounded-full" data-id="element-137"></div>
      <div className="container mx-auto max-w-6xl z-10" data-id="element-138">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-139">
          <div className="lg:w-7/12" data-id="element-140">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="relative" data-id="element-141">
              <div className="inline-block px-4 py-1 mb-4 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-sm font-medium" data-id="element-142">
                <span className="flex items-center gap-1" data-id="element-143">
                  <SparklesIcon size={16} data-id="element-144" />
                  <span data-id="element-145">CLASE EN VIVO · 21 DE MARZO</span>
                </span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 leading-tight" data-id="element-146">
                Cómo crear y vender tu propio producto digital usando IA
              </h1>
              <p className="text-lg md:text-xl text-gray-300 mb-6" data-id="element-147">
                Descubre el método paso a paso para crear, lanzar y vender
                productos digitales sin conocimientos técnicos, sin mostrar tu
                cara y sin complicaciones.
              </p>
              {!isFormSubmitted && !showForm && <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="px-8 py-4 rounded-lg bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white font-bold text-lg relative overflow-hidden group" onClick={handleOpenForm} data-id="element-148">
                  <span className="relative z-10" data-id="element-149">Registrarme Gratis</span>
                  <span className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-150"></span>
                </motion.button>}
              {isFormSubmitted && <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="p-6 rounded-lg border border-purple-500 bg-purple-900/20 text-center" data-id="element-151">
                  <h3 className="text-2xl font-bold mb-2" data-id="element-152">
                    ¡Registro Exitoso!
                  </h3>
                  <p className="text-gray-300" data-id="element-153">
                    Te has registrado correctamente para la clase en vivo.
                    Revisa tu correo electrónico para los detalles de acceso.
                  </p>
                </motion.div>}
            </motion.div>
          </div>
          <div className="lg:w-5/12" data-id="element-154">
            {showForm && !isFormSubmitted && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3
          }} className="bg-gray-900/80 backdrop-blur-sm p-6 rounded-xl border border-gray-800" data-id="element-155">
                <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-156">
                  Reserva tu lugar ahora
                </h3>
                <RegisterForm onSuccess={handleFormSuccess} data-id="element-157" />
              </motion.div>}
          </div>
        </div>
      </div>
      <WhatsAppJoinModal isOpen={showWhatsAppModal} onClose={() => setShowWhatsAppModal(false)} data-id="element-158" />
    </section>;
};